import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import React from 'react'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'

async function cancelLayout({ identificador, numero_nota, sequencia, codprod, observacao }) {
  const response = await api.post(`/site/v2/fluxo-layout/cancelar-layout-pendente`, {
    identificador,
    numero_nota,
    sequencia,
    codprod,
    observacao
  })

  return response.data
}

export function CancelarLayout({ layout }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: cancelLayout,
    onSuccess: () => {
      toast({
        title: 'Layout cancelado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      queryClient.invalidateQueries('layouts')

      onClose()
    },
    onError: () => {
      toast({
        title: 'Erro ao cancelar layout',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  })

  async function handleCancelLayout() {
    try {
      await mutateAsync({
        identificador: layout.id,
        numero_nota: layout.numero_nota,
        sequencia: layout.sequencia,
        codprod: layout.codigo_produto,
        observacao: 'Cancelado pelo vendedor'
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Button colorScheme='red' size="sm" onClick={onOpen}>
        Cancelar Layout
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Cancelar Layout - {layout.numero_pedido}
            </AlertDialogHeader>

            <AlertDialogBody>
              Você tem certeza que deseja cancelar esse layout?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Fechar
              </Button>
              <Button 
                colorScheme='red' 
                ml={3}
                onClick={handleCancelLayout}
                isLoading={isLoading}
              >
                Cancelar Layout
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}